



















import Vue from 'vue';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default Vue.extend<any, any, any, any>({
  name: 'CtrlProgress',
  props: {
    value: {
      type: Number,
      default: 0,
      required: true,
    },
    steps: {
      type: Number,
      default: 0,
      required: true,
    },
    title: {
      type: String,
      default: null,
      required: true,
    },
  },
  data: () => ({
    show: true,
  }),
  computed: {
    graphValue() {
      return (this.value / this.steps) * 100;
    },
  },
});
